<mat-toolbar class="header-topnav mat-elevation-z2" style="background-color: white; color: #434E5F; position: fixed;">
  <span fxFlex></span>
  <div class="topnav">
    <!-- App Logo -->

    <button *ngIf="layoutConf.isMobile" mat-icon-button id="sidenavToggle" (click)="toggleSidenav()" matTooltip="Esconder/Mostrar Menu">
      <mat-icon>menu</mat-icon>
    </button>

    <ul class="menu">
      <li *ngFor="let item of menuItems; let i = index;">
        <div *ngIf="item.type !== 'separator'" routerLinkActive="open">
          <a (click)="scrollTo(item.state)" *ngIf="item.type === 'link'">
            <mat-icon>{{item.icon}}</mat-icon>
            {{item.name}}
          </a>
          <div *ngIf="item.type === 'dropDown'">
            <label matRipple for="drop-{{i}}" class="toggle">
              <mat-icon>{{item.icon}}</mat-icon> {{item.name}}
            </label>
            <a matRipple>
              <mat-icon>{{item.icon}}</mat-icon> {{item.name}}
            </a>
            <input type="checkbox" id="drop-{{i}}" />
            <ul>
              <li *ngFor="let itemLvL2 of item.sub; let j = index;" routerLinkActive="open">
                <a matRipple routerLink="{{item.state ? '/'+item.state : ''}}/{{itemLvL2.state}}" *ngIf="itemLvL2.type !== 'dropDown'">
                  <mat-icon *ngIf="itemLvL2.icon">{{itemLvL2.icon}}</mat-icon>
                  {{itemLvL2.name}}
                </a>

                <div *ngIf="itemLvL2.type === 'dropDown'">
                  <label matRipple for="drop-{{i}}{{j}}" class="toggle">{{itemLvL2.name}}</label>
                  <a matRipple>
                    <mat-icon *ngIf="itemLvL2.icon">{{itemLvL2.icon}}</mat-icon> {{itemLvL2.name}}
                  </a>
                  <input type="checkbox" id="drop-{{i}}{{j}}" />
                  <!-- Level 3 -->
                  <ul>
                    <li *ngFor="let itemLvL3 of itemLvL2.sub" routerLinkActive="open">
                      <a matRipple routerLink="{{item.state ? '/'+item.state : ''}}{{itemLvL2.state ? '/'+itemLvL2.state : ''}}/{{itemLvL3.state}}">
                        <mat-icon *ngIf="itemLvL3.icon">{{itemLvL3.icon}}</mat-icon>
                        {{itemLvL3.name}}
                      </a>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </li>
    </ul>
    <!-- End Navigation  <span fxFlex></span>-->


  </div>

</mat-toolbar>
